import type { Ref, InjectionKey, VueElementConstructor } from "vue";
import { DateTime } from "luxon";
import type {
  ActionListActionFieldsFragment,
  EventListEventFieldsFragment,
  IEventOption,
} from "@/graphql";
import type { SerializedFilter } from "./FilterSerializer";

export type UserId = number;

export enum FilterEntity {
  EVENT,
  ACTION,
}

export type FilterEvent = {
  type: FilterEntity;
  index: number;
};

export enum AddFilterButtonPosition {
  left = "left",
  right = "right",
}

export class Filter {
  isNegated?: boolean;

  static UI: VueElementConstructor<any>;

  static Badge: VueElementConstructor<any>;

  serialize?(): SerializedFilter["values"];

  static deserialize?(values: SerializedFilter["values"]): Filter;
}

export interface EventFilter extends Filter {
  isEventActive: (event: EventListEventFieldsFragment, boardId?: number) => boolean;
}

export interface ActionFilter extends Filter {
  isActionActive: (action: ActionListActionFieldsFragment) => boolean;
}

export type EventFilters = {
  updatedAt: DateTime;
  eventFilters: EventFilter[];
};

export type ActionFilters = {
  updatedAt: DateTime;
  actionFilters: ActionFilter[];
};

export const EventFilterInjectionKey = Symbol("EventFilterInjectionKey") as InjectionKey<
  Ref<EventFilters>
>;
export const ActionFilterInjectionKey = Symbol("ActionFilterInjectionKey") as InjectionKey<
  Ref<ActionFilters>
>;

export const JumpToEventInjectionKey = Symbol("JumpToEventInjectionKey") as InjectionKey<
  (eventToJumpTo: IEventOption) => void
>;
